<div class="mt-5">
    <div class="d-flex-center">
        <img src="assets/images/descarga-app-invitado.png" style="width: 180px;">
    </div>
</div>

<div class="row text-center" *ngIf="typeMessage == 0">
    <div class="col-12 font-h5">
        ¡Descargá Givi para utilizar y administrar tus Givis!
    </div>

    <div class="col-12 font-c1 text-muted">
        Cuando descargués el app utilizá tu usuario <br>
        Usuario: <b>{{userLogin}}</b>
    </div>
</div>

<div class="row text-center" *ngIf="typeMessage == 1">
    <div class="col-12 font-h5">
        ¡Tu solicitud para ser parte de la comunidad ya se envió!
    </div>

    <div class="col-12 font-c1">
        Descargá Givi para acceder a tus beneficios e ingresá tu usuario <br>
        Usuario: <b>{{userLogin}}</b>
    </div>
</div>

<div class="row text-center" *ngIf="typeMessage == 2">
    <div class="col-12 font-h5">
        ¡Listo, ya sos parte de la comunidad!
    </div>

    <div class="col-12 font-c1">
        Descargá Givi para acceder a tus beneficios y utilizá tu usuario <br>
        Usuario: <b>{{userLogin}}</b>
    </div>
</div>

<div class="m-t-20 d-flex-center">
    <div class="m-t-20">
        <a href="https://giviapp.com" target="_blank" class="download">
            <img src="assets/images/iosAssign.png" style="width: 125px;">
        </a>
    </div>
    <div class="m-t-20">
        <a href="https://giviapp.com" target="_blank" class="download">
            <img src="assets/images/androidAssign.png" style="width: 125px;">
        </a>
    </div>
</div>